<template>
  <div id="root">
    <modal
      :show="show"
      :show-header="false"
    >
      <h4
        class="title"
        v-if="!selectedStudent"
      >
        Who do you want to make a graduation record for?
      </h4>
      <h4
        class="title"
        v-if="selectedStudent"
        style="font-weight:normal;"
      >
        Make a grad form for<br><span style="font-weight:bold">{{ selectedStudent.name }}</span>?
      </h4>
      <h5 v-if="!students" style="text-align:center">
        Loading...
      </h5>
      <el-autocomplete
        v-if="students"
        v-model="query"
        placeholder="Search people"
        :fetch-suggestions="queryStudents"
        value-key="name"
        @select="handleSelectStudent"
        id="searchAutocomplete"
        v-show="!selectedStudent"
        style="width: 100%;"
      />
      <div>
        <p-button style="float: right" @click="handleClose()">
          Cancel
        </p-button>
        <p-button
          v-if="selectedStudent && !isSaving"
          style="float: right"
          class="custom-modal-type"
          @click="handleSave()"
        >
          Yes
        </p-button>
        <p-button
          v-if="isSaving"
          disabled
          style="float: right"
          class="custom-modal-type"
        >
          Saving...
        </p-button>
      </div>
    </modal>
  </div>
</template>

<script>
import modal from '../UIComponents/Modal';
import { RepositoryFactory } from '../../repositories/repositoryFactory';

const GraduationRecordsRepository = RepositoryFactory.get('graduationRecords');

export default {
    name: 'AddGradForm',
    components: {
        modal,
    },
    data() {
        return {
            namespace: 'GraduationRecords',
            selectedStudent: null,
            query: '',
            isSaving: false,
        };
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        students: {
            type: Array,
            default() { return []; }
        }
    },
    methods: {
        handleSave() {
            this.isSaving = true;
            GraduationRecordsRepository.createNewGraduationRecord(this.selectedStudent.id)
                .then((response) => {
                    this.$emit('newRecordSaved', response.data);
                    this.handleClose();
                    this.isSaving = false;
                })
                .catch((error) => {
                    this.$message(error.response.data.message);
                    this.handleClose();
                    this.isSaving = false;
                });
        },
        handleClose() {
            this.selectedStudent = null;
            this.query = '';
            this.$emit('close');
        },
        queryStudents(queryString, callback) {
            if (queryString.length === 0) callback(this.students);
            else {
                const results = queryString
                    ? this.students.filter(this.createFilter(queryString)) : this.students;
                callback(results);
            }
        },
        createFilter(queryString) {
            return (student) => student.name.toLowerCase().includes(queryString.toLowerCase());
        },
        handleSelectStudent(student) {
            this.selectedStudent = student;
        },
    },
};
</script>
